/* global axios */
import ApiClient from './ApiClient';

class IxcLookupAPI extends ApiClient {
  constructor() {
    super('ixc_lookup', { apiVersion: 'v2', accountScoped: true });
  }

  searchClients(query) {
    return axios.get(`${this.url}/search`, { params: { query } });
  }

  listContracts(clienteId) {
    return axios.get(`${this.url}/contracts`, { params: { cliente_id: clienteId } });
  }

  clientStatus({ clienteId, contratoId }) {
    return axios.get(`${this.url}/client_status`, {
      params: { cliente_id: clienteId, contrato_id: contratoId },
    });
  }

  linkClient({ contactId, clienteId }) {
    return axios.post(`${this.url}/link_client`, { contact_id: contactId, cliente_id: clienteId });
  }

  linkContract({ conversationId, contratoId }) {
    return axios.post(`${this.url}/link_contract`, { conversation_id: conversationId, contrato_id: contratoId });
  }

  trustUnlock({ contratoId, conversationId }) {
    return axios.post(`${this.url}/trust_unlock`, { contrato_id: contratoId, conversation_id: conversationId });
  }

  listInvoices(clienteId) {
    return axios.get(`${this.url}/invoices`, { params: { cliente_id: clienteId } });
  }

  consumo(contratoId) {
    return axios.get(`${this.url}/consumo`, { params: { contrato_id: contratoId } });
  }

  osAssuntos() {
    return axios.get(`${this.url}/os_assuntos`);
  }

  osResumo(conversationId) {
    return axios.post(`${this.url}/os_resumo`, { conversation_id: conversationId });
  }

  openOs({ clienteId, contratoId, assuntoId, mensagem, filialId, osSetorId, ticketSetorId, tecnicoId, conversationId }) {
    return axios.post(`${this.url}/open_os`, {
      cliente_id: clienteId,
      contrato_id: contratoId,
      assunto_id: assuntoId,
      mensagem,
      filial_id: filialId,
      os_setor_id: osSetorId,
      ticket_setor_id: ticketSetorId,
      tecnico_id: tecnicoId,
      conversation_id: conversationId,
    });
  }

  getBoletoPdf({ invoiceId, conversationId }) {
    return axios.post(`${this.url}/second_copy`, { invoice_id: invoiceId, conversation_id: conversationId });
  }

  resetPppoe({ contratoId, conversationId }) {
    return axios.post(`${this.url}/reset_pppoe`, { contrato_id: contratoId, conversation_id: conversationId });
  }

  sendPix({ invoiceId, conversationId, invoiceAmount, invoiceDueDate, clientName }) {
    return axios.post(`${this.url}/send_pix`, {
      invoice_id: invoiceId,
      conversation_id: conversationId,
      invoice_amount: invoiceAmount,
      invoice_due_date: invoiceDueDate,
      client_name: clientName,
    });
  }

  toggleAi({ conversationId, active }) {
    const base = this.url.replace(/\/ixc_lookup$/, '');
    return axios.post(`${base}/conversations/${conversationId}/ai_toggle`, { active });
  }

  listAudits(conversationId) {
    const base = this.url.replace(/\/ixc_lookup$/, '');
    return axios.get(`${base}/ixc_audit`, { params: { conversation_id: conversationId } });
  }
}

export default new IxcLookupAPI();
